/* ============================================================================
   MoveOn™ Listicle landing page — interactions
   ----------------------------------------------------------------------------
   Vanilla port of the Claude Design comp's `Component extends DCLogic` class
   (project ad05f006-36ce-435b-8777-8f74d1a60391). No framework, no support.js.
   Drives:
     • hero carousel   (6 slides, auto-advance, dot controls, reset-on-pick)
     • offer gallery   (cross-fade + thumbnails)
     • bundle + plan   (live pricing across CTA, cart drawer and sticky bar)
     • cart drawer     (slide-in summary, Esc / scrim to close)
     • FAQ + ingredient accordions (single-open)
     • review wall     (3 columns auto-scrolling at different speeds)
     • generations chart (bars grow when the block scrolls in)
     • sticky add-to-cart bar (reveals past 620px)
     • all [data-pro] videos (force muted + looping, never unmutable)
   ============================================================================ */
(function () {
  'use strict';

  var AUTOPLAY_MS = 6000;      // autoplaySeconds = 6 (was 4; Brandon 2026-08-10)
  var SHOW_STICKY = true;      // comp prop: showStickyBar = true
  var DEFAULT_PLAN = 'sub';    // comp prop: defaultPlan = 'sub'

  var state = { slide: 0, gal: 0, bundle: 1, plan: DEFAULT_PLAN, bar: false, cartOpen: false };

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function fmt(n) { return '$' + (Number.isInteger(n) ? String(n) : n.toFixed(2)); }
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

  /* ---------------------------------------------------------------- hero -- */
  var heroTrack = $('[data-hero-track]');
  var heroDots = $$('[data-hero-dot]');
  var heroCount = heroTrack ? heroTrack.children.length : 0;
  var heroTimer = null;

  function renderHero() {
    if (!heroTrack) return;
    heroTrack.style.transform = 'translateX(-' + (state.slide * 100) + '%)';
    heroDots.forEach(function (d, i) { d.classList.toggle('is-active', i === state.slide); });
  }

  function startHeroTimer() {
    if (heroTimer) clearInterval(heroTimer);
    if (!heroCount || reduceMotion) return;
    heroTimer = setInterval(function () {
      state.slide = (state.slide + 1) % heroCount;
      renderHero();
    }, AUTOPLAY_MS);
  }

  heroDots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      state.slide = i;
      renderHero();
      startHeroTimer();          // picking a dot restarts the clock, as in the comp
    });
  });

  /* ------------------------------------------------------------- gallery -- */
  var galSlides = $$('[data-gal-slide]');
  var galThumbs = $$('[data-gal-thumb]');

  function renderGallery() {
    galSlides.forEach(function (img, i) { img.classList.toggle('is-active', i === state.gal); });
    galThumbs.forEach(function (b, i) {
      b.classList.toggle('is-active', i === state.gal);
      b.setAttribute('aria-current', i === state.gal ? 'true' : 'false');
    });
  }

  galThumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { state.gal = i; renderGallery(); });
  });

  /* ------------------------------------------------- bundle / plan / cart -- */
  /* Bundle, plan, cart drawer and checkout live in assets/mo-offer.js (shared with
     the PDP). This page only keeps its sticky bar's supply in step: "90 Days" / "30 Days"
     (Brandon 2026-10-03: days, not box counts). The cards' full "90-Day Supply" does not fit
     here - it is cut off on every phone up to 390px wide - so the bar uses the short form.
     The [data-cta-price] figures are written by mo-offer.js directly. */
  var barSupply = function (d) {
    var t = window.MoOffer && window.MoOffer.tiers && window.MoOffer.tiers[d.bundle];
    return t ? t.days + ' Days' : d.label;
  };
  document.addEventListener('mo-offer:change', function (e) { setText('[data-bar-bundle]', barSupply(e.detail)); });
  if (window.MoOffer && window.MoOffer.detail) setText('[data-bar-bundle]', barSupply(window.MoOffer.detail()));

  /* ---------------------------------------------------------- accordions -- */
  // Single-open per group, matching the comp (faqOpen defaults to item 0,
  // the offer's ingredient accordion defaults to closed).
  $$('[data-acc]').forEach(function (group) {
    var items = $$('.mo-acc-item', group);
    items.forEach(function (item) {
      var btn = $('.mo-acc-btn', item);
      var panel = $('.mo-acc-panel', item);
      var sym = $('.mo-acc-sym', item);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var willOpen = !panel.classList.contains('is-open');
        items.forEach(function (other) {
          var p = $('.mo-acc-panel', other);
          var b = $('.mo-acc-btn', other);
          var s = $('.mo-acc-sym', other);
          if (p) p.classList.remove('is-open');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (s) s.textContent = '+';
        });
        if (willOpen) {
          panel.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (sym) sym.textContent = '−';
        }
      });
    });
  });

  /* --------------------------------------------------------- sticky bar -- */
  var stickyBar = $('[data-sticky-bar]');

  function onScroll() {
    var show = window.scrollY > 620;
    if (show === state.bar) return;
    state.bar = show;
    if (stickyBar) stickyBar.classList.toggle('is-up', show && SHOW_STICKY);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* -------------------------------------------------------------- video -- */
  // Every [data-pro] clip stays muted and looping, and can never be unmuted.
  // Only the clips actually on screen are told to play: there are 16 of them, and
  // asking a browser to run 16 concurrent streams (worse inside an embedded
  // preview iframe, e.g. the Shopify theme editor) is what makes them sit frozen
  // on the poster frame. The observer keeps 2-3 playing at a time instead.
  var vids = $$('video[data-pro]');
  var onScreen = new WeakSet();

  // Save-Data / slow connection: never pull video, the poster frames carry the section.
  var conn = navigator.connection || {};
  var lowData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');

  function tryPlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  // src lives in data-src, so a clip costs nothing until it is actually reached.
  // Five 480p clips is still ~11 MB, which has no business downloading during a
  // page load nobody has scrolled yet.
  function ensureSrc(v) {
    if (v.dataset.src && !v.src) {
      v.preload = 'auto';
      v.src = v.dataset.src;
    }
  }

  function forceMute() {
    vids.forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.volume = 0; v.loop = true;
      if (v.paused && onScreen.has(v) && v.src) tryPlay(v);
    });
  }

  if ('IntersectionObserver' in window && !lowData) {
    var vObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          onScreen.add(v);
          ensureSrc(v);
          v.muted = true; v.loop = true;
          tryPlay(v);
        } else {
          onScreen.delete(v);
          if (!v.paused) v.pause();
        }
      });
    }, { rootMargin: '100px 0px', threshold: 0.01 });
    // wait for load so video never competes with the content people came for
    var startObserving = function () { vids.forEach(function (v) { vObs.observe(v); }); };
    if (document.readyState === 'complete') setTimeout(startObserving, 300);
    else window.addEventListener('load', function () { setTimeout(startObserving, 300); });
  } else if (!lowData) {
    vids.forEach(function (v) { onScreen.add(v); ensureSrc(v); });
  }

  forceMute();
  document.addEventListener('volumechange', forceMute, true);
  document.addEventListener('pause', forceMute, true);
  setInterval(forceMute, 3000);
  // an embedded preview can start hidden; re-assert when it becomes visible
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) forceMute();
  });

  /* -------------------------------------------------------- review wall -- */
  function startReviewWall() {
    var cols = $$('.mo-vcol');
    if (!cols.length || reduceMotion) return;
    var wall = $('.mo-vwall');
    var paused = false;
    var holdTimer = null;

    function hold() { paused = true; if (holdTimer) clearTimeout(holdTimer); }
    function release(ms) {
      if (holdTimer) clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { paused = false; }, ms);
    }

    if (wall) {
      wall.addEventListener('pointerenter', hold);
      wall.addEventListener('pointerleave', function () { release(200); });
      wall.addEventListener('touchstart', hold, { passive: true });
      wall.addEventListener('touchend', function () { release(2500); }, { passive: true });
      wall.addEventListener('wheel', function () { hold(); release(2000); }, { passive: true });
    }

    var pos = cols.map(function (c) { return c.scrollTop; });
    cols.forEach(function (c, i) {
      c.addEventListener('scroll', function () {
        // adopt the user's position when they drag a column themselves
        if (paused || Math.abs(c.scrollTop - Math.round(pos[i])) > 2) pos[i] = c.scrollTop;
      }, { passive: true });
    });

    var last = performance.now();
    (function step(now) {
      var dt = Math.min((now - last) / 1000, 0.08);
      last = now;
      if (!paused) {
        cols.forEach(function (c, i) {
          var half = c.scrollHeight / 2;   // each track holds the cards twice
          if (half < 40) return;
          var track = c.firstElementChild;
          var speed = Number(track && track.dataset.speed) || 20;
          var p = pos[i] + speed * dt;
          if (p >= half) p -= half;
          pos[i] = p;
          c.scrollTop = Math.round(p);
        });
      }
      requestAnimationFrame(step);
    })(last);
  }

  /* ------------------------------------------------------------- chart --- */
  function startChartReveal() {
    var chart = $('.mo-chart');
    if (!chart) return;
    if (!('IntersectionObserver' in window)) { chart.classList.add('is-in'); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    obs.observe(chart);
  }

  /* --------------------------------------------------------------- init -- */
  renderHero();
  startHeroTimer();
  renderGallery();
  onScroll();
  startReviewWall();
  startChartReveal();
})();

/* Copy/save protection: no context menu or drag on media, no copy of page text. */
(function () {
  var root = document.querySelector('.mo-listicle');
  if (!root) return;
  root.addEventListener('contextmenu', function (e) {
    if (e.target.closest('img, video')) e.preventDefault();
  });
  root.addEventListener('dragstart', function (e) {
    if (e.target.closest('img, video, a')) e.preventDefault();
  });
  root.addEventListener('copy', function (e) { e.preventDefault(); });
})();
